<div class="sa-login body flex">
  <div class="sa-login-container flex col-12 h-100">
    <div class="sa-login-details flex-6 flex-col flex">
      <sa-icon img="{{product_logo}}" imgWidth="110" imgHeight="38" [href]="sarasLink" [hrefTarget]="'blank'" ></sa-icon>
      <div class="sa-login-details-content flex-center flex-col h-100 left">
        @if (webflowContentReady && LoginSignupPage.cards.length) {
        <div class="md-flex md-flex-col">
          <div class="sa-login-details-title title md-title text-32 md-m-0">{{LoginSignupPage.cards[0].fieldData['card-title']}}</div>
          <div class="text title md-text md-m-0">
            {{LoginSignupPage.cards[0].fieldData['card-subtitle']}}
          </div>
        </div>
        }
      </div>
    </div>

    <div class="sa-login-form flex-6 flex flex-center">
      @if(!showWorkEmailForm){
      <div class="sa-form-container">

        @if(isLoading){
          <div class="sa-form-overlay"></div>
          } @if(toast){
          <sa-toast
            class="block"
            [subHeading]="toast.subHeading || ''"
            [status]="toast.status || 'success'"
            width="100%"
          ></sa-toast>
          }
        
        <div class="title md-title" [style.visibility]="product ? '' : 'hidden'">Login to your <span>{{product}} account</span></div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <formly-form
            [form]="form"
            [model]="model"
            [fields]="fields"
            (modelChange)="modelChangeHandler($event)"
          >
          </formly-form>
          <div class="text text-14 text-low md-text">
            Don't remember?
            <a class="" href="javascript:void(0)" (click)="showWorkEmailForm = true"
              >Reset Password</a
            >
          </div>

          <div class="sa-login-checkbox">
            <mat-checkbox [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">
              <span class="sub-title md-text">Remember me</span>
            </mat-checkbox>
          </div>

          <sa-button
            [isSubmit]="true"
            text="Login"
            type="primary"
            size="medium"
            state="default"
            width="100%"
            [showSpinner]="isLoading"
          ></sa-button>
        </form>
        @if(signupLink){
          <span class="sub-title sa-login-footer"
            >Don’t have an account?
            <a [href]="signupLink" class="link">Create account</a></span
          >
        }
      </div>
      }@else{
      <sa-work-email-form class="flex-center"></sa-work-email-form>
      }
    </div>
  </div>
</div>
